import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const trelloColors = {
  green: '#61BD4F',
  yellow: '#F2D600',
  orange: '#FFAB4A',
  red: '#EB5A46',
  purple: '#C377E0',
  blue: '#0079BF',
  lime: '#51E898',
  pink: '#FF80CE',
  sky: '#00C2E0',
  black: '#4d4d4d',
  null: '#B6BBBF',
};

const StyledLabel = styled.div`
  color: white;
  background-color: ${(p) => trelloColors[p.color] || trelloColors.null};
  border-radius: 3px;
  display: inline-block;
  font-size: 1.2rem;
  font-weight: 600;
  min-width: 40px;
  max-width: 100%;
  padding: 0 8px;
  width: auto;
`;

function TrelloLabel({ label }) {
  return (
    <StyledLabel color={label.color}>
      {label.name || <span>&nbsp;</span>}
    </StyledLabel>
  );
}

TrelloLabel.propTypes = {
  label: PropTypes.object,
};
export default TrelloLabel;



// WEBPACK FOOTER //
// ./src/components/TrelloLabel.js